import { BookmarkButton, CanNotRemoveModal, YesNoModal } from "@/components"

export default {
  
  data() {
    return {
      loading: true,
      saving: false,
      checkingName: false,
      checkingRemoval: false,
      removing: false,
      isCreating: false,
      isUpdating: false,
      allowed: true,
      creatingTitle: "",
      updatingTitle: "",
      confirmNameMessage: "",
    }
  },

  components: { 
    BookmarkButton,
    CanNotRemoveModal, 
    YesNoModal,
  },

  created() {      
    this.initFormPage()
  },    

  methods: {

    initFormPage() {

      this.loading = true
      this.saving = false
      this.checkingRemoval = false
      this.removing = false      
      this.isCreating = false
      this.isUpdating = false
      this.allowed = true

      if (this.$route.params.id == "new") {
        this.isCreating = true        
        this.loading = false
      } else {
        this.isUpdating = true
      }
    },

    goBack() {
      if (this.indexRoute) {
        this.$router.push(this.indexRoute)
      } else {
        this.$historyBack()
      }
    },
  },
}